import { LoadingRegion } from "@commerce/components/page";
import { EvalsScreen } from "@commerce/evals/EvalsScreen";
import { evalsSearchSchema } from "@commerce/evals/meta";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { orpc } from "@shared/lib/orpc";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_saas/app/_org/$organizationSlug/evals")(
	{
		validateSearch: evalsSearchSchema,
		shouldReload: false,
		loader: async ({ context }) => {
			const organizationId = context.organization.id;
			const queryClient = getServerQueryClient();
			await queryClient.ensureQueryData(
				orpc.evals.overview.queryOptions({ input: { organizationId } }),
			);
			return {
				organizationId,
				dehydratedState: dehydrateForLoader(queryClient),
			};
		},
		head: () => ({ meta: [{ title: `Evals - ${config.appName}` }] }),
		component: EvalsPage,
	},
);

function EvalsPage() {
	const { organizationId, dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={
				<LoadingRegion label="Loading evals" className="min-h-64" />
			}
			dehydratedState={dehydratedState}
		>
			<EvalsScreen organizationId={organizationId} />
		</AsyncBoundary>
	);
}
